// extracted by mini-css-extract-plugin
module.exports = {"button":"YesNoButtons_button__ymNG5","selectedButton":"YesNoButtons_selectedButton__tUOum"};